// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import Typography from "@insite/mobius/Typography";
import TextArea from "@steiner/MobiusOverrides/TextArea/TextArea";
import { cartLineNotesStyles, CartLineNotesStyles } from "@steiner/Overrides/Widgets/Cart/CartLineNotes";
import { maxLengthNotes } from "@steiner/XDL/Utilities";
import React, { FC } from "react";

interface OwnProps {
    orderLine: OrderLineModel;
    extendedStyles?: CartLineNotesStyles;
}

type Props = OwnProps;

const OrderLineNotes: FC<Props> = ({ orderLine, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(cartLineNotesStyles, extendedStyles));
    const notes = orderLine.notes;
    return (
        <>
            <Typography {...styles.readOnlyNotesText}>{notes}</Typography>
            <StyledWrapper {...styles.wrapper}>
                {notes && (
                    <TextArea
                        {...styles.editableNotesTextArea}
                        value={notes}
                        id={`notes-${orderLine?.id}`}
                        disabled={true}
                        data-test-selector="orderline_notes"
                        type="notes"
                        maxLength={maxLengthNotes}
                    />
                )}
            </StyledWrapper>
        </>
    );
};

export default OrderLineNotes;
